module.exports = __webpack_public_path__ + "img/cpzz1@2x.4e942474.png";